import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './global.css'
import App from './App.jsx'
import IconSprite from './components/icons/IconSprite.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <IconSprite />
    <App />
  </StrictMode>,
)
